export default "__VITE_PUBLIC_ASSET__e4bd863d__"